import { useContext, useMemo } from "react";
import { Navigate, useParams } from 'react-router-dom';
import { AuthContext } from "../../context/AuthContext";
import DashboardApi from "../../api/DashboardApi";
import Dashboard from "../../components/Dashboard/index";
import InternalLayout from "../../components/layouts/InternalLayout";
import Loader from "../../components/Loader";
import UWEContext from "../../context/UWEContext";
import useResourceLoader from "../../util/useResourceLoader";

function TrayView() {
  const auth = useContext(AuthContext);

  const { slug } = useParams();

  const { dashboards } = useContext(UWEContext);

  const { dashboardId, redirectTo } = useMemo(() => {
    let dashboardId = dashboards?.filter(db => db.slug === slug).pop()?.id;
    let redirectTo;
    
    if (dashboardId === undefined) {
      if (slug === "home") {
        dashboardId = dashboards[0]?.id;
      } else {
        redirectTo = dashboards[0]?.slug;
      }
    }
    return {dashboardId, redirectTo};
  }, [dashboards, slug]);

  const [
    dashboard,
    loadingDashboard,
    errorLoadingDashboard
  ] = useResourceLoader(
    async () => (dashboardId ? DashboardApi.get({ id: dashboardId }) : null),
    [dashboardId]
  );

  const TrayComponent = useMemo(() => {
    if (!dashboard) return null;

    const schema = {
      wrapperType: "internal",
      ...dashboard,
      schema: dashboard.definition
    };

    return Dashboard.HOC(schema);
  }, [auth, dashboard]);

  return loadingDashboard ? (
    <InternalLayout>
      <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Loader  />
      </div>
    </InternalLayout>
  ) : redirectTo ? (
    <Navigate replace to={`/workflow/${redirectTo}/tray`} />
  ) : TrayComponent ? (
    <TrayComponent />
  ) : (
    <ErrorTray />
  );
}

const ErrorTray = Dashboard.HOC({
  wrapperType: "internal",
  schema: {
    type: "dashboard",
    elements: [
      {
        type: "text",
        label: "Tray not Found"
      }
    ]
  }
});

export default TrayView;
